import { useState } from 'react';
import {
  INDIVIDUAL_DEFAULT_METHOD, readLastUsedAddMethod, writeLastUsedAddMethod, type AddMethod,
} from './addAssetMethod';

/**
 * SIL-1182: individual-org "remember last-used add-asset method". Reads
 * storage exactly once, on mount (the lazy `useState` initializer), so a
 * later `rememberMethod` write from this same page never yanks the
 * selection out from under a user mid-session. `rememberMethod` is a
 * write-through — call it only from a capture-success path (a completed
 * manual/scan submission, or a matched TrueRead reading), never from mere
 * card selection.
 */
export function useAddAssetMethodMemory(userKey: string | null | undefined): {
  initialMethod: AddMethod;
  rememberMethod: (method: AddMethod) => void;
} {
  const [initialMethod] = useState<AddMethod>(
    () => readLastUsedAddMethod(userKey) ?? INDIVIDUAL_DEFAULT_METHOD,
  );
  return {
    initialMethod,
    rememberMethod: (method: AddMethod) => writeLastUsedAddMethod(userKey, method),
  };
}
